import { formatDateForAPI } from 'helpers/formatters';
import React from 'react';

const PinnedNote = ({ notes, updateNote }) => {
  const pinnedNote = notes.find((note) => note.pinned);

  const handleUnpinNote = () => {
    updateNote(pinnedNote.id, { pinned: false }).catch((e) => {
      console.log(e);
    });
  };

  if (!pinnedNote) {
    return null;
  }

  return (
    <div className="pinned-note">
      <div className="d-flex-vc pinned-note-header">
        <img src="/images/icons/pins/pin-icon.png" alt="" />
        <h4 className="h4">Pinned Note</h4>
      </div>
      <div className="d-flex-vc flex-justify-space-between">
        <p className="mar-r">{pinnedNote.text}</p>
        <div className="d-flex-vc">
          <p>
            <b>Updated At:</b> {formatDateForAPI(pinnedNote.updated_at)}
          </p>
          <button className="btn btn-default mar-l" onClick={handleUnpinNote}>
            Unpin Note
          </button>
        </div>
      </div>
    </div>
  );
};

export default PinnedNote;
